<template>
    <v-tabs color="grey lighten-3" grow v-model="selected">
        <v-tab href="#lot-tab-notes">Notes</v-tab>
        <v-tab href="#lot-tab-owner">Vendeur</v-tab>
        <v-tab href="#lot-tab-bidnormal">Ordres fermes</v-tab>
        <v-tab href="#lot-tab-bidtel">Ordres tél</v-tab>

        <v-tabs-items touchless>
            <v-tab-item value="lot-tab-notes" lazy>
                <pad-lot-notes :item="item" />
            </v-tab-item>
            <v-tab-item value="lot-tab-owner" lazy>
                <pad-lot-owner :item="item" />
            </v-tab-item>
            <v-tab-item value="lot-tab-bidnormal" lazy>
                <pad-lot-bid :item="item" type="normal" />
            </v-tab-item>
            <v-tab-item value="lot-tab-bidtel" lazy>
                <pad-lot-bid :item="item" type="tel" />
            </v-tab-item>
        </v-tabs-items>
    </v-tabs>
</template>

<script>
import PadLotNotes from '@/components/PadLotNotes'
import PadLotOwner from '@/components/PadLotOwner'
import PadLotBid from '@/components/PadLotBid'

export default {
    name: 'pad-lot-list-expand',
    components: { PadLotNotes, PadLotOwner, PadLotBid },
    props: {
        item: { type: Object }
    },
    data: () => ({
        selected: null
    }),
    mounted() {
        this.selected = this.$route.query.tab
    },
    methods: {
        select(tab) {
            this.selected = tab
        }
    }
}
</script>
